import {observable} from "mobx";
import http from 'libs/http';
import {message} from 'antd';
import lodash from 'lodash'
import{addVisitLog, history} from 'libs';
import goodStore from 'pages/goods/store';

class Store {
  @observable records = [];
  @observable homeProductRecords = {};
  @observable hotRecords = [];
  @observable userAddRecords = [];
  @observable mallCategoryNoAllList = [];
  @observable record = {};
  @observable file = {};
  @observable recordId = 0;
  @observable isFetching = false;
  @observable keywords = null;
  @observable mallCategory = [
    {
      value:'P0001',
      label:'设备',
    },
    {
      value:'P0002',
      label:'耗材',
    },
    {
      value:'P0003',
      label:'其他',
    },
  ];
  @observable page = 1;
  @observable pageSize = 24;
  @observable pageTotal = 0;

  fetchRecords = () => {
    const submitData = {pageNo: this.page, pageSize: this.pageSize,param:{keywords:this.keywords,mallCategoryOne:this.mallCategoryOne,mallCategoryTwo:this.mallCategoryTwo}}
    addVisitLog({
      pageName: '产品列表',
      fromPageUrl: window.referrerUrl,
      pageUrl:`${window.location.origin}${history.location.pathname}`,
      eventCode: "ProductList",
      eventName: "查看产品列表",
      content: JSON.stringify(submitData),
    })
    this.isFetching = true;
    // lang=en zh
    http.post('/javaApi/front/product/list',submitData)
      .then(res =>{
        this.records = res.data.result.data
        this.pageTotal = res.data.result.pageInfo.totalRows
      })
      .finally(() => this.isFetching = false)
  };
      //请求首页产品列表
  fetchHomeProductRecords = () => {
      http.get('/javaApi/front/product/getHomeCategorySkuList')
      .then(res =>{
        this.homeProductRecords = res.data.result;
        
      })
      .finally(() => this.isFetching = false)
  }

  fetchMallCategoryList = () => {
      http.post('/javaApi/mallCategory/listAll')
      .then(res =>{
        const allList = {
          label:'所有产品',
          level:1,
          value:null,
          children:[{
            label:'所有产品',
            level:2,
            value:null,
          }]}
          this.mallCategoryNoAllList = res.data.result;
      })
      .finally(() => this.isFetching = false)
  }

  authFileUrl = (params)=>{
    return http.post('/javaApi/oss/authFileUrl',params);
  }

  getFile = (params)=>{
    return http.post('/javaApi/oss/getFileUrl',params);
  }


  deleteFile = (params)=>{
    return http.post('/javaApi/oss/delFile',params);
  }

  pageChange = (page, size) => {
    this.records = []
    this.page = page;
    this.pageSize = size;
    this.fetchRecords()
  }

  fetchHotRecords = () => {
    this.isFetching = true;
    http.get('/javaApi/front/product/getHotList?is_hot=' + this.recordId)
      .then(res => this.hotRecords = res.data.result)
      .finally(() => this.isFetching = false)
  }

  fetchRecord = (lang = 'zh') => {
    this.isFetching = true;
    return http.get('/javaApi/front/product/getDetail?id=' + this.recordId + '&lang=' + lang)
      .then(res => {
        this.record = res.data.result;
      })
      .finally(() => this.isFetching = false)
  }

    // 添加、更新用户自己添加的商品
    updateUserAddRecord = (data, index = 0) => {
      this.userAddRecords[index] = data
    }

      //提交求购
  postInquiry = () => {
    if (goodStore.userAddRecords.length) {
      if (!goodStore.userAddRecords.every(v=>v.name)) {
        return message.error("品名不能为空！")
      }
      if (!goodStore.userAddRecords.every(v=>v.formats)) {
        return message.error("规格不能为空！")
      }
      if (goodStore.userAddRecords.some(v=>v.name?.length>200)) {
        return message.error("品名不能超过200个字！")
      }
      if (goodStore.userAddRecords.some(v=>v.brand?.length>50)) {
        return message.error("品牌不能超过50个字！")
      }
      if (goodStore.userAddRecords.some(v=>v.formats?.length>50)) {
        return message.error("规格不能超过50个字！")
      }
      if (goodStore.userAddRecords.some(v=>v.factoryCode?.length>100)) {
        return message.error("货号不能超过100个字！")
      }
      if (goodStore.userAddRecords.some(v=>v.cartRemarks?.length>50)) {
        return message.error("购物车备注不能超过50个字！")
      }
      addVisitLog({
        pageName: '搜索求购',
        fromPageUrl: window.referrerUrl,
        pageUrl:`${window.location.origin}${history.location.pathname}`,
        eventCode: 'SearchCreateInquiry',
        eventName: "搜索求购",
        content: JSON.stringify({list:goodStore.userAddRecords}),
      })
      return http.post('/javaApi/front/cart/createInquiry', {inquiryItems:goodStore.userAddRecords,attachmentPath:goodStore.file.filePath,attachmentName:goodStore.file.fileName})
      .then(res => {
        message.success('提交求购成功')
        goodStore.userAddRecords = [];
        goodStore.file = {};
      })
      .catch(err => {
        message.error(err || '提交求购失败')
      })
    }else{
      message.error("商品不能为空！")
    }
  }
}

export default new Store()
